import { ToggleGroup } from '@plerionhq/design-system/experimental';
import { REVIEW_PRESET_DAYS, presetDateInput } from '../../lib/review-date';

// Short enough that four fit across a popover or a slide-over field.
function presetLabel(days: number): string {
  return days >= 365 ? '1y' : `${days}d`;
}

const PRESET_ITEMS = REVIEW_PRESET_DAYS.map((days) => ({
  value: String(days),
  label: presetLabel(days),
}));

/**
 * One-click review-date offsets, shared by every place a review date is picked so
 * the shortcuts cannot drift between them.
 *
 * `value` is a 'YYYY-MM-DD' date-input value; a preset shows as selected only
 * while the date still matches what it would produce today.
 */
export function ReviewDatePresets({
  value,
  onChange,
}: {
  value: string;
  onChange: (dateInputValue: string) => void;
}) {
  return (
    <ToggleGroup
      type="single"
      items={PRESET_ITEMS}
      value={
        PRESET_ITEMS.find(
          (item) => presetDateInput(Number(item.value)) === value,
        )?.value ?? ''
      }
      onValueChange={(next: string) => {
        // Radix reports '' when the active item is clicked again. Ignored: the
        // presets are shortcuts, not a way to clear the date.
        if (next) {
          onChange(presetDateInput(Number(next)));
        }
      }}
    />
  );
}
